import { render, staticRenderFns } from "./textInputGdprItem.vue?vue&type=template&id=d58f3e22"
import script from "./textInputGdprItem.vue?vue&type=script&lang=js"
export * from "./textInputGdprItem.vue?vue&type=script&lang=js"
import style0 from "./textInputGdprItem.vue?vue&type=style&index=0&id=d58f3e22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports